export enum BarcodeCheck {
  EMPTY_BARCODE = 'EmptyBarcode',
  MULTIPLE_ACTIVE = 'MultipleActive',
  NO_MEMBERSHIP = 'NotExist',
  CHECKED_IN = 'CheckedIn',
  CHECKED_OUT = 'CheckedOut',
  OUTSIDE_HOURS = 'OutsideHours',
  SKIPPED = 'Skipped',
}
